/** @file Draw-order timeline: each key's full slot permutation as setup slot indices (null = setup). */
import type { AnimationDoc, TimelineJson } from '@pose2d/format/types';
import { discreteTimeline } from './discreteTimeline';
import { requireCompiledIndex } from './requireCompiledIndex';

/** null when the animation has no draw-order keys. */
export function drawOrderTimeline(anim: AnimationDoc, fps: number, slotIndex: ReadonlyMap<string, number>, at: string): TimelineJson | null {
  if (anim.drawOrder.length === 0) return null;
  const toIndices = (order: string[] | null): number[] | null => (order === null ? null : order.map((id) => requireCompiledIndex(slotIndex, id, 'slot', `${at}.drawOrder`)));
  return { k: 'drawOrder', ...discreteTimeline(anim.drawOrder.map((key) => ({ f: key.f, v: key.order })), fps, toIndices) };
}
